import { Injectable } from '@angular/core';
import { PublicationFileGetByDocumentIdInput, PublicationFileGetByDocumentIdOutPut } from 'src/app/core/actions/use-case/publication-file-get-by-document-id.service';
import { PublicationListByProcessIdOutPut } from 'src/app/core/actions/use-case/publication-list-by-process-id.service';
import { ApiResponse } from 'src/app/infra/http/type';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PublicationFileRemoteRepositoryService {

  private baseUrl = `${environment.apiURLStage.slice(0, -1)}/PresidentialActions`; // Your base URL

  constructor(
    private http: HttpService
  ) { }

  async listByProcessId(processId: string) {
    console.log(this.baseUrl);
    return await this.http.get<ApiResponse<PublicationListByProcessIdOutPut>>(`${this.baseUrl}/${processId}/Posts`);
  }

  async FileListByDocumentId(input: PublicationFileGetByDocumentIdInput) {
    return await this.http.get<ApiResponse<PublicationFileGetByDocumentIdOutPut>>(`${this.baseUrl}/Posts/${input.documentId}/file`);
  }
}
